import { render, staticRenderFns } from "./ItemAlertStockStatus.vue?vue&type=template&id=b86f761a&scoped=true"
import script from "./ItemAlertStockStatus.vue?vue&type=script&lang=ts"
export * from "./ItemAlertStockStatus.vue?vue&type=script&lang=ts"
import style0 from "./ItemAlertStockStatus.vue?vue&type=style&index=0&id=b86f761a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86f761a",
  null
  
)

export default component.exports